export default __webpack_public_path__ + "static/media/blood4.b8bae33b.png";